module.exports = __webpack_public_path__ + "assets/icn-installation.32343600.svg";